

export default class InventoryGalleryModel {

    constructor(data) {

      // TODO: add validation for mandatory items
      let template = {
        id: 0,
        brigadeId: null,
        description: null,
        image: null
      };

      this.data = data ? data : template;
    }

   
    toJson = () => {
      return JSON.stringify(this.data);
    }

    getId = () => {
        return this.data.id;
    }

    setId = (value) => {
      this.data.id = value;
    }

    getBrigadeId = () => {
      return this.data.brigadeId;
    }

    setBrigadeId =(value) => {
      this.data.brigadeId = value;
    }

    getDescription = () => {
      return this.data.description;
    }

    setDescription = (value) => {
      this.data.description= value;
    }
    
    getImage = () => {
      return this.data.image;
    }

    setImage = (value) => {
      this.data.image = value;
    }

}